<template>
  <el-form-item :label="label" :prop="name">
    <el-input
      v-on="$listeners"
      v-bind="$attrs"
      :type="type"
      :id="name"
      v-model="filteredValue"
      :placeholder="placeholder || label"
      :disabled="disabled"
      :data-testid="'importantNotes'"
      :class="'text-input'"
      :autosize="{ minRows: minRows, maxRows: maxRows }"
    ></el-input>
  </el-form-item>
</template>
<script>
export default {
  name: 'ImportantNotesInput',
  model: {
    prop: 'inputValue',
    event: 'returnModel'
  },
  props: {
    inputValue: String,
    label: String,
    placeholder: String,
    name: String,
    disabled: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    minRows: {
      type: Number,
      default: 5
    },
    maxRows: {
      type: Number,
      default: 6
    }
  },
  computed: {
    filteredValue: {
      get() {
        return this.inputValue;
      },
      set(newValue) {
        this.$emit('returnModel', newValue.replace(/"/g, ''));
      }
    }
  }
};
</script>
